import { utilToUiDate } from 'app/home/common/utils/iso-date-type/to-iso-date';
import { CoApplicantInfoQuoteFormInput } from 'app/home/create-quote/forms/co-applicant-info/co-applicant-info.types';
import type { QuoteDraftSelectorState } from 'app/home/global-store/quote-draft';

export function coApplicantInfoQuoteFormSelector(store: QuoteDraftSelectorState): CoApplicantInfoQuoteFormInput {
  const { coApplicant } = store;

  // update the date string
  const lastName = coApplicant()?.lastName ?? '';
  const firstName = coApplicant()?.firstName ?? '';
  const dob = coApplicant()?.dob;
  const formattedDob = dob ? utilToUiDate(dob) : '';

  return { firstName, lastName, dob: formattedDob ?? '' };
}
